// extracted by mini-css-extract-plugin
export var parcelRow = "_rr-0";